import {
  mapActions
} from 'vuex';
import ResetPasswordI18n from './ResetPassword.i18n.js';

export default {

  components: {},

  props: {},

  computed: {
    isPasswordValid() {
      if (this.password1 === '' && this.password2 === '') {
        return null
      } else {
        if (this.password2 === this.password1) {
          return true
        } else {
          return false
        }
      }
    }
  },

  data() {
    return {
      password1: '',
      password2: '',
      error: false
    };
  },

  watch: {},

  methods: {
    ...mapActions(['resetPassword']),
    resetCurrentPassword() {
      const info = {
        password: this.password1,
        uniqueCode: this.$route.params.uniqueCode
      }
      this.resetPassword(info).then(res => {
        this.$router.push({
          path: `/`
        })
      }).catch(err => {
        this.error = true
        console.log(err)
      })
    }
  },

  mounted() {
    window.scrollTo(0, 0)
  },

  i18n: ResetPasswordI18n,

};